import { getEntityName } from "../../../utils/user/get-entity-name"

interface NameableParty {
  first_name?: string | null
  middle_name?: string | null
  last_name?: string | null
  name?: string | null
}

interface NameableLead {
  lead_name?: string | null
  customer?: NameableParty | null
  temporary_customer?: NameableParty | null
}

/**
 * `lead_name` is optional — the create wizard only insists on the customer — so
 * a bare placeholder is the one reading the workspace header must never show.
 * The customer the lead was raised for names it instead, and only a lead with
 * neither falls back to the untitled label.
 */
const leadDisplayName = (
  lead: NameableLead | null | undefined,
  untitled: string
): string => {
  const named = lead?.lead_name?.trim()
  if (named) return named

  const customer = lead?.customer || lead?.temporary_customer
  const customerName = getEntityName(customer, "")?.trim()

  return customerName || untitled
}

export { type NameableLead, leadDisplayName }
